module.exports = __webpack_public_path__ + "static/media/bin.1896bd86.svg";